import React, { useState, createContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Fragment } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Hero from "./components/Hero";
import Content from "./components/Content";
import Courses from "./components/Courses";
import Blog from "./components/Blog";
import { LanguagesPage } from "./components/Languages/Languages";
import GuideDetail from "./components/Languages/GuideDetail"; // New component for a single guide
import LanguageGuides from "./components/Languages/LanguageGuides";

import Contact from "./components/Contact";
import About from "./components/About";
import DetailPage from "./components/Blog/DetailPage";
import Register from "./components/Register";
import Testimonial from "./components/Testimonial";
import Profile from "./components/Profile";
import ToolDetails from "./components/OurTools/ToolDetails";
import OurTools from "./components/OurTools/OurTools";
import Cart from "./components/Cart/Cart";
import Wishlist from "./components/Wishlist/Wishlist";
import MyTools from "./components/MyTools/MyTools";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import Compiler from "./components/Compiler/Compiler";

import "./App.css";

// Context for theme handling
export const ThemeContext = createContext(null);

function App() {
  const [theme, setTheme] = useState("dark");
  const [mode] = useState();

  // Function to toggle theme
  const toggleTheme = () => {
    setTheme((curr) => (curr === "light" ? "dark" : "light"));
  };

  return (
    <Router>
      <ThemeContext.Provider value={{ theme, toggleTheme }}>
        <div className="App" id={theme}>
          {/* Navbar */}
          <Navbar mode={mode} toggleTheme1={toggleTheme} theme1={theme} />

          <Routes>
            {/* Home Page */}
            <Route
              exact
              path="/"
              element={
                <Fragment>
                  <Hero mode={mode} />
                  <Content mode={mode} />
                  <Testimonial mode={mode} />
                </Fragment>
              }
            />
            {/* Courses Page */}
            <Route exact path="/courses" element={<Courses mode={mode} />} />
            {/* Blog Page */}
            <Route exact path="/blog" element={<Blog mode={mode} />} />
            <Route
              exact
              path="/languages"
              element={<LanguagesPage mode={mode} />}
            />
            <Route path="/languages/:languageId" element={<LanguageGuides mode={mode} />} />
            <Route path="/guides/:uid" element={<GuideDetail mode={mode}/>} />

            
            {" "}
            {/* Add mode */}
            {/* Blog detail page */}
            <Route
              exact
              path="/blog/detail/:slug"
              element={<DetailPage mode={mode} />}
            />
            {/* Contact Page */}
            <Route exact path="/contact" element={<Contact mode={mode} />} />
            {/* About Page */}
            <Route exact path="/about" element={<About mode={mode} />} />
            {/* Register and Login Pages */}
            <Route
              exact
              path="/login-register"
              element={<Register mode={mode} />}
            />
            {/* Profile Page */}
            <Route exact path="/profile" element={<Profile mode={mode} />} />
            {/* Our Tools Page */}
            <Route exact path="/our-tools" element={<OurTools mode={mode} />} />
            <Route
              exact
              path="/our-tools/:slug"
              element={<ToolDetails mode={mode} />}
            />
            {/* Cart Page */}
            <Route exact path="/cart" element={<Cart mode={mode} />} />
            {/* Wishlist Page */}
            <Route exact path="/wishlist" element={<Wishlist mode={mode} />} />
            {/* My Tools Page */}
            <Route exact path="/my-tools" element={<MyTools mode={mode} />} />
            {/* T&C Page */}
            <Route
              exact
              path="/terms-and-conditions"
              element={<TermsAndConditions mode={mode} />}
            />
            {/* Compiler Page */}
            <Route exact path="/compiler" element={<Compiler mode={mode} />} />
          </Routes>

          {/* Footer */}
          <Footer mode={mode} />
        </div>
      </ThemeContext.Provider>
    </Router>
  );
}

export default App;
